import React from 'react';
import { IRadiouGroup, RadioGroupOption } from './RadioGroup.types';
import RadioTile from './RadioTile/RadioTile';
import { RadioTileValue } from './RadioTile/RadioTile.types';
import './RadioGroup.css';

const RadioGroup: IRadiouGroup = ({
  disabled,
  maxRow = maxNumOfRowElements,
  name,
  options,
  radioCircleLeft,
  selectedValue,
  onChangeSelection,
}) => {
  const optionsHaveIcons = options.every(option => option.icon);
  const hasMaxNumOfElementsInARow = options.length > maxRow;
  const isChecked = (currentValue: RadioTileValue) => currentValue === selectedValue;
  const isColumn = !optionsHaveIcons && hasMaxNumOfElementsInARow;
  const inlineDisplay = radioCircleLeft ?? !optionsHaveIcons;
  return (
    <div
      className={`radio-group ${isColumn ? 'radio-group--column' : ''}
        ${optionsHaveIcons ? 'radio-group--with-icons' : ''}`}
      data-testid="radio-group"
    >
      {options.map(({ title, value, description, icon }: RadioGroupOption) => (
        <RadioTile
          key={`radio-tile-${value}`}
          title={title}
          subtitle={description}
          value={value}
          disabled={disabled}
          name={name}
          checked={isChecked(value)}
          icon={icon}
          inlineDisplay={inlineDisplay}
          handleClick={onChangeSelection}
        />
      ))}
    </div>
  );
};

const maxNumOfRowElements = 2;

export default RadioGroup;
